/**
 * Общие строки: действия кнопок и состояния, которые повторяются на многих
 * экранах. Одна формулировка — одно сообщение: «Повторить» не переводится
 * трижды тремя разными словами.
 */
import { defineMessages } from './define';

export const COMMON = defineMessages({
  signIn: { id: 'common.action.signIn', defaultMessage: 'Войти' },
  signOut: { id: 'common.action.signOut', defaultMessage: 'Выйти' },
  retry: { id: 'common.action.retry', defaultMessage: 'Повторить' },
  reload: { id: 'common.action.reloadPage', defaultMessage: 'Перезагрузить страницу' },
  cancel: { id: 'common.action.cancel', defaultMessage: 'Отмена' },
  clear: { id: 'common.action.clear', defaultMessage: 'Очистить' },
  skipToContent: { id: 'common.action.skipToContent', defaultMessage: 'К содержимому', description: 'Ссылка для клавиатуры: перейти к основному содержимому' },
  noReason: { id: 'common.state.noReason', defaultMessage: 'причина не названа' },
  loadErrorTitle: {
    id: 'common.state.loadError.title',
    defaultMessage: 'Не удалось загрузить {what}',
    description: '{what} — что не загрузилось, в винительном падеже («темп кампании»); передаёт экран',
  },
  loadErrorReason: {
    id: 'common.state.loadError.reason',
    defaultMessage: 'Это ошибка связи с сервером, а не отсутствие данных.',
  },
  renderFailedTitle: { id: 'common.state.renderFailed.title', defaultMessage: 'Экран не отрисован: {message}' },
  renderFailedReason: {
    id: 'common.state.renderFailed.reason',
    defaultMessage:
      'Сайдбар и шапка работают: перейдите в другой раздел или обновите страницу — падение одного экрана не роняет остальную станцию.',
  },
  checkingSignIn: { id: 'common.state.checkingSignIn', defaultMessage: 'Проверяем, кто вошёл…' },
  loadingCabinet: { id: 'common.state.loading.cabinet', defaultMessage: 'кабинет', description: 'Что загружается (подпись скелетона для диктора)' },
  loadingSection: { id: 'common.state.loading.section', defaultMessage: 'раздел', description: 'Что загружается (подпись скелетона для диктора)' },
});
